import * as angular from 'angular';
import * as _ from "lodash";
import {GlobalSearchItemsType} from "../../search/types/global-search-items.type";
import {AnalyticsService} from "../../commons/services/analytics-service.service";
import {IQService} from "angular";
import {DeliveriesAlertsService} from "./deliveries-alerts.service";
import {DeliveriesRequestsService} from "./deliveries-requests.service";
import {OmsRequestsService} from "../../oms/services/oms-requests.service";
import {BillingAlertsService} from "../../billing-accounts/services/billing-alerts.service";
import {GlobalSearchService} from "../../search/services/global-search-service.service";
import {SettingsAlertsService} from "../../site-preferences/services/settings-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../commons/services/commons-dialog.service";
import {CommonsService} from "../../commons/services/commons-service.service";
import {TaskModel} from "../../tasks/models/task.model";
import {Service} from "../models/service.model";
import {ServicesUpdateMetadataRequestModel} from "../models/services-update-metadata-request.model";
import {MissingItemModel} from "../models/missing-item.model";
import {OperationalContactModel} from "../../commons/angular/models/operational-contact.model";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";

export class DeliveriesService {

  constructor(private deliveriesRequestsService: DeliveriesRequestsService, private omsRequestsService: OmsRequestsService, private $log, private deliveriesAlertsService: DeliveriesAlertsService,
              private $delivery, private billingAlertsService: BillingAlertsService, private splitService, private settingsAlertsService: SettingsAlertsService,
              private bringozLoaderService: BringozLoaderService, private commonsDialogService: CommonsDialogService, private analyticsService: AnalyticsService,
              private $q: IQService, private commonsAlertsService: CommonsAlertsService, private commonsService: CommonsService,
              private commonsConstants, private globalSearchService: GlobalSearchService) {
  }

  addDeliveryAttachments() {
    return this.commonsService.fileUpload(this.commonsConstants.fileConstants.upload.images)
      .then((uploadedResult) => {
        const imageUrl = _.get(uploadedResult, 'url'),
          mimeType = _.get(uploadedResult, 'contentType'),
          fileName = _.get(uploadedResult, 'filename'),
          originalFilename = _.get(uploadedResult, 'originalFilename');
        if (imageUrl) {
          return this.$q.when({
            url: imageUrl,
            mimeType: mimeType,
            name: fileName,
            originalFilename: originalFilename
          });
        }
      }).catch((error) => {
        this.$log.info(error);

        if (error.data.message === "Constraint violation failed") {
          this.commonsAlertsService.fileFormatError();
        }
        return this.$q.reject(error);
      })
  }

  getPickups(delivery) {
    return _.filter(delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Pickup';
    })
  }

  getDropoffs(delivery) {
    return _.filter(delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Dropoff';
    })
  }

  getUnpackedDeliveryIds(services) {
    if (!_.isArray(services)) {
      services = [services];
    }
    const deliveries = _.filter(services, (s) => {
      return s.serviceType === 'Delivery';
    });
    const unpackedServiceIds = [];
    _.forEach(deliveries, (d) => {
      let unpackedCounter = 0;
      _.forEach(d.packageList[0].items, (item) => {
        if (item.count > 0) {
          unpackedCounter++;
        }
      });

      if (unpackedCounter === 0) {
        unpackedServiceIds.push(d.id);
      }
    });

    return unpackedServiceIds;
  }

  isDeliveryUnpacked(items) {
    let unpackedCounter = 0;
    _.forEach(items, (item) => {
      if (item.count > 0) {
        unpackedCounter++;
      }
    });
    return unpackedCounter === 0;
  }

  getUnpackedPackages(items) {
    return _.filter(items, (item) => {
      return item.count < 1;
    });
  }

  // Set the notBefore and notAfter that are chosen on delivery:
  setTimesOnDelivery(delivery?, notBefore?, notAfter?, selectedQuote?, quote?) {
    delivery.notBefore = _.get(selectedQuote, 'startTime') || _.get(selectedQuote, 'defaultStartTime') || notBefore;
    delivery.notAfter = _.get(selectedQuote, 'endTime') || _.get(selectedQuote, 'defaultEndTime') || notAfter;

    _.forEach(delivery.taskList, (t) => {
      if (_.get(selectedQuote, 'type') === 'DynamicTimeSlot' && t.taskSpec.purpose === 'Pickup') {
        t.taskSpec.notBefore = _.get(selectedQuote, 'pickupStartTime');
        t.taskSpec.notAfter = _.get(selectedQuote, 'pickupEndTime');
      } else {
        if (!selectedQuote) {
          t.taskSpec.notBefore = notBefore;
          t.taskSpec.notAfter = notAfter;
        } else {
          t.taskSpec.notBefore = _.get(selectedQuote, 'startTime') || _.get(selectedQuote, 'defaultStartTime');
          t.taskSpec.notAfter = _.get(selectedQuote, 'endTime') || _.get(selectedQuote, 'defaultEndTime');
        }
      }
    });
  }

  updateDeliveryQuote(delivery?, quote?, from?, to?) {

    const notBeforeRef = from ? from : _.get(quote, 'startTime') || _.get(quote, 'defaultStartTime');
    const notAfterRef = to ? to : _.get(quote, 'endTime') || _.get(quote, 'defaultEndTime');

    delivery.notBefore = notBeforeRef;
    delivery.notAfter = notAfterRef;

    _.forEach(delivery.taskList, (t) => {
      if (_.get(quote, 'type') === 'DynamicTimeSlot' && t.taskSpec.purpose === 'Pickup') {
        t.taskSpec.notBefore = _.get(quote, 'pickupStartTime') || notBeforeRef;
        t.taskSpec.notAfter = _.get(quote, 'pickupEndTime') || notAfterRef;
      } else {
        t.taskSpec.notBefore = notBeforeRef;
        t.taskSpec.notAfter = notAfterRef;
      }
    });

    delivery.quote = quote;

    delivery.urgency = _.get(quote, 'urgency', 'Other');
    // delivery.type = _.get(quote, 'type');

    if (_.get(quote, 'defaultVehicleType') && !delivery.vehicleType) {
      delivery.vehicleType = _.get(quote, 'defaultVehicleType');
    }
  }

  updateDeliveryQuotePerTask(delivery, notBeforePickup, notAfterPickup, notBeforeDropoff, notAfterDropoff, vehicleType) {
    delivery.notBefore = notBeforePickup;
    delivery.notAfter = notAfterDropoff;

    _.forEach(delivery.taskList, (t) => {
      t.taskSpec.notBefore = notBeforePickup;
      t.taskSpec.notAfter = notAfterPickup;
    });

    delivery.urgency = 'Other';
    delivery.type = 'PerTask';

    if (!delivery.vehicleType) {
      delivery.vehicleType = vehicleType;
    }
    return delivery;
  }

  changeToBackInStore(backInStoreReason, deliveryId) {
    return this.deliveriesRequestsService.changeToBackInStore(backInStoreReason, deliveryId)
      .then((task: TaskModel) => {
        this.deliveriesAlertsService.backInStoreSuccess();
      })
      .catch((error) => {
        this.deliveriesAlertsService.backInStoreError();
        this.$log.error('Failed to proceed with back in store @taskStatusButton@onChangeStatus', error);
      })
  }

  updateService(service, isShouldSendSms) {
    this.bringozLoaderService.on();
    return this.$delivery(service.id).$update(service, {}, {sendSms: isShouldSendSms})
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  cancelService(ev, ids, serviceType, cancelReason) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.cancelDelivery(ids, cancelReason)
      .then((deletedDeliveries) => {
        if (ids.length > 1) {
          this.deliveriesAlertsService.cancelManySuccess();
        } else {
          this.deliveriesAlertsService.cancelSuccess(deletedDeliveries[0])
        }
      })
      .catch((error) => {
        if (error) {
          if (ids.length > 1) {
            this.deliveriesAlertsService.cancelManyError();
          } else {
            this.deliveriesAlertsService.cancelError();
          }
          this.$log.error('Failed to canceled delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Cancel', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Cancel', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getDeliveryServiceAreasMap(delivery) {
    const areasMap = {};
    _.forEach(delivery.taskList, (task: TaskModel) => {
      const taskAreasRef = angular.copy(task.taskSpec.address.areaIdToNameMap);
      _.forEach(taskAreasRef, (area) => {
        if (!areasMap.hasOwnProperty(area)) {
          areasMap[area] = taskAreasRef[area];
        }
      })
    });
    return areasMap;
  }

  getDeliveryServiceAreasIdsList(delivery) {
    const areaIds = [];
    _.forEach(delivery.taskList, (task: TaskModel) => {
      let taskAreasIdsRef = angular.copy(task.taskSpec.address.areaIdList);
      _.forEach(taskAreasIdsRef, (id) => {
        if (!_.includes(areaIds, id)) {
          areaIds.push(id);
        }
      })
    });
    return areaIds;
  }

  getDeliveryBilling(serviceId) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.getDeliveryBilling(serviceId)
      .catch((error) => {
        this.billingAlertsService.getError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  updateServiceBilling(serviceId, billing) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.updateServiceBilling(serviceId, billing)
      .then(() => {
        this.billingAlertsService.updateSuccess();
      })
      .catch((error) => {
        this.billingAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  updateServiceProNumber(service) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.updateServiceProNumber(service)
      .then(() => {
        this.deliveriesAlertsService.updateDeliverySuccess(service);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateDeliveryError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getGlobalSearch(query: string, orgId: string, siteId: string, branchIds: string[], cursor, limit: number, autoComplete: boolean = true,
                  sortMethod?: SuperSearchSortMethodType) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.getGlobalSearch(query, orgId, siteId, branchIds, cursor, limit, autoComplete, sortMethod)
      .then(services => {
        return this.globalSearchService.itemToItemOfType(services, GlobalSearchItemsType.Services);
      })
      .catch(() => {
        this.deliveriesAlertsService.getGlobalSearchError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  updateServiceMetaData(serviceId: string, metaData: {key: string, value: string}[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateServiceMetaData(serviceId, metaData)
      .then((service: Service) => {
        this.commonsAlertsService.updateMetaDataSuccess();
        deferred.resolve(service);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMetaDataError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateServicesMetaData(payload: ServicesUpdateMetadataRequestModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateServicesMetaData(payload)
      .then((services: Service[]) => {
        this.commonsAlertsService.updateMetaDataSuccess();
        deferred.resolve(services);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMetaDataError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateMissingItem(serviceId: string, missingItems: MissingItemModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateMissingItem(serviceId, missingItems)
      .then((services: Service[]) => {
        this.commonsAlertsService.updateMissingItemsSuccess();
        deferred.resolve(services);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMissingItemsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOperationalContacts(serviceId: string, operationalContacts: OperationalContactModel[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateOperationalContacts(serviceId, operationalContacts)
      .then((services: Service[]) => {
        // this.deliveriesAlertsService.updateDeliverySuccess()
        deferred.resolve(services);
      })
      .catch((error) => {
        // this.commonsAlertsService.updateMissingItemsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getRelatedServicesByTypeMultiple(services, relationType: string, includeSelf?: boolean): string[] {
    let relatedServicesIds = [];
    _.forEach(services, (service) => {
      relatedServicesIds = _.union(relatedServicesIds, this.getRelatedServicesByTypeSingle(service, relationType, includeSelf));
    })

    if (!includeSelf) {
      const servicesIds = _.map(services, (s) => {
        return s.id
      })
      relatedServicesIds = _.differenceBy(_.uniq(relatedServicesIds), servicesIds);
    }
    return includeSelf ? _.uniq(relatedServicesIds) : relatedServicesIds;
  }

  getRelatedServicesByTypeSingle(service, relationType: string, includeSelf?: boolean): string[] {

    let relatedServicesIds = [];
    _.forEach(service.taskList, (task: TaskModel) => {
      const relations = _.get(task, "relations", undefined);
      if (relations) {
        const filteredServiceIds = relations.filter((relation) => {
          return (relation.type === relationType
            && (includeSelf || relation.details.serviceId !== service.id))
        }).map((filteredTasks) => {
          return filteredTasks.details.serviceId;
        });
        if (filteredServiceIds.length) {
          relatedServicesIds = _.union(relatedServicesIds, filteredServiceIds)
        }
      }
    })

    return relatedServicesIds;
  }

}

angular
  .module('bringoz.admin.deliveries')
  .service('deliveriesService', DeliveriesService);
